<template>
	<div id="app" >
		<div id="login-page" v-if="$route.name == 'login'" >
			<div class="container">
				<div class="login-form">
					<div class="main-div">
						<router-view/>
					</div>
					<p class="botto-text">Desenvolvido por Jointech - 2020</p>
				</div>
			</div>
		</div>
		<div id="home-page" v-else >
			<menu-header></menu-header>
			<div id="layoutSidenav">
				<side-bar></side-bar>
				<div id="layoutSidenav_content" class="py-3" @click.prevent="disableSidebar()" >
                    <div class="container-fluid">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
								<router-link :to="{name: 'home'}">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item active">
                                {{$route.meta.name}}
                            </li>
                        </ol>
                    </div>
					<main>
						<vue-page-transition name="fade-in-left">
							<router-view/>
						</vue-page-transition>
					</main>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import menuHeader from '@/components/menuHeader.vue'
	import sideBar from '@/components/sideBar.vue'
	export default {
		components: {
			menuHeader,
			sideBar
		},
		computed: {
			isLogged(){
				return this.$store.getters.getLogged
			},

			userInfo(){
				return this.$store.state.user
			}
		},
		methods: {
			disableSidebar: function(){
				let menu = document.getElementById('app-body')
				if(menu.classList.contains('sb-sidenav-toggled')){
					menu.classList.remove('sb-sidenav-toggled')
				}
			},

			verifyAuth: function(){
				this.$getItem('gestor-board')
					.then(response => {
						if (response != null || response != undefined){
							// Permite o usuario usar o sistema
							console.log('Login response', '=>', response)
							this.$store.commit('login', response)
							this.$router.push({
								name: 'home'
							})
						}else{
							// Envia o usuario para a tela de login
							this.$router.push({
								name: 'login'
							})
						}
					}, error => {
						console.error('Auth exception', '=>', error)
						// Envia o usuario para a tela de login
						this.$router.push({
							name: 'login'
						})
					})
			}
		},
		// mounted(){
		// 	this.verifyAuth()
		// },
		created(){
			console.log(process.env.ROOT_API)
			this.verifyAuth()
		}
	}
</script>
<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: #2c3e50;

		width: 100% !important;
		height: 100% !important;
		min-height: 100% !important;
	}

	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	#nav a.router-link-exact-active {
		color: #42b983;
	}

	#login-page{ 
		background-image:url("https://hdwallsource.com/img/2014/9/blur-26347-27038-hd-wallpapers.jpg"); 
		background-repeat:no-repeat; 
		background-position:center; 
		background-size:cover; 
		padding:10px;

		width: 100% !important;
		height: 100% !important;
		min-height: 100% !important;
	}

 	.form-heading { 
		color:#fff; 
		font-size:23px;
	}

	.login-form .form-control {
		background: #f7f7f7 none repeat scroll 0 0;
		border: 1px solid #d4d4d4;
		border-radius: 4px;
		font-size: 14px;
		height: 50px;
		line-height: 50px;
	}
	.main-div {
		background: #ffffff none repeat scroll 0 0;
		border-radius: 2px;
		margin: 10px auto 30px;
		max-width: 50%;
		padding: 50px 70px 70px 71px;
	}
	@media screen and (max-width: 768px){
		.main-div{
			background: #ffffff none repeat scroll 0 0;
			border-radius: 2px;
			margin: 10px auto 30px;
			max-width: 100%;
			padding: 20px 40px 40px 41px;
		}
	}
	.login-form{ 
		text-align:center;
	}

	.botto-text {
		color: #ffffff;
		font-size: 14px;
		margin: auto;
	}

	/* #home-page{
		padding-top: 75px;
	}*/
	#layoutSidenav_content{
		justify-content: initial !important;
	}
</style>
